import React from 'react';

import {
  Table,
} from 'UI';
import { ClientLocation } from 'constants/interface';
import { AddClientLocationFormData } from '../LocationModal';

import {
  MainContainer,
  DeleteButton,
} from './style';

interface LocationAddListProps {
  locationsToAdd: AddClientLocationFormData[]
  onDelete(index: number): void
  isLoading?: boolean
}

const LocationAddList = ({
  locationsToAdd,
  onDelete,
  isLoading,
}: LocationAddListProps): JSX.Element => (
  <MainContainer>
    <Table
      dataSource={locationsToAdd}
      loading={isLoading}
      pagination={false}
      showSorterTooltip={false}
    >
      <Table.Column
        title="Encarregado"
        key="maintainer"
        dataIndex="maintainer"
      />
      <Table.Column
        title="Fazenda"
        key="name"
        dataIndex="name"
      />
      <Table.Column
        title="Cidade"
        key="city"
        dataIndex="city"
        render={(city: string, clientLocation: ClientLocation) => (
          <span>{`${city ? `${city}/${clientLocation.state}` : '-'}`}</span>
        )}
      />
      <Table.Column
        title=""
        key="details"
        dataIndex="id"
        render={(val, rec, index) => (
          <>
            {/* TODO: fix edit location to add modal bug */}
            {/* <EditButton onClick={() => onEdit(index)}>
              editar
            </EditButton>
            | */}
            <DeleteButton onClick={() => onDelete(index)}>
              remover
            </DeleteButton>
          </>
        )}
      />
    </Table>
  </MainContainer>
);

LocationAddList.defaultProps = {
  isLoading: false,
};

export default LocationAddList;
